<div class="status-card {{cor}}" [ngStyle]="{'background-color': backgroundColor}">
    <div class="status-content">
      <div>
        <div class="status-text {{cor}}">
          {{ texto }}
        </div>
        <div class="status-descricao" [innerHTML]="descricao">
        </div>
      </div>
      <div class="status-icon-wrapper">
        <mat-icon class="status-icon">{{ icone }}</mat-icon>
        <div class="status-dot {{cor}}"></div>
      </div>
    </div>
  </div>